import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class ComplaintResponseModel extends GlobalResponseObject {
    data?: any;
    response: any[];
}
export class AllComplaintResponseModel extends GlobalResponseObject{
    data?: any[];
    percentData?:any;
}

export class SignalComplaintResponseModel extends GlobalResponseObject{
    data?: any;
}

